import { PageContainer } from '@/components/organisms'
import { SectionTitle, TabsComponent } from '@/components/molecules'
import { FONT_SIZE } from '@/utils/constants/globalStyle'
import { DisplayForm } from '@/containers/ClubPlus/CreateTier/phases/Display/Form'
import { useIntl } from 'react-intl'
import { useMemo } from 'react'

export const Display = ({ tierData }) => {
  const { formatMessage } = useIntl()

  const tabLangs = useMemo(() => [
    { id: formatMessage({ id: 'LANGUAGES.ENGLISH_ID' }), tabLabel: formatMessage({ id: 'LANGUAGES.ENGLISH_LABEL' }), title: formatMessage({ id: 'LANGUAGES.ENGLISH_LABEL' }), tabComponent: <DisplayForm key={formatMessage({ id: 'LANGUAGES.ENGLISH_ID' })} language={formatMessage({ id: 'LANGUAGES.ENGLISH_ID' })} tierData={tierData} /> },
    { id: formatMessage({ id: 'LANGUAGES.SPANISH_MEXICO_ID' }), tabLabel: formatMessage({ id: 'LANGUAGES.SPANISH_MEXICO_LABEL' }), title: formatMessage({ id: 'LANGUAGES.SPANISH_MEXICO_LABEL' }), tabComponent: <DisplayForm key={formatMessage({ id: 'LANGUAGES.SPANISH_MEXICO_ID' })} language={formatMessage({ id: 'LANGUAGES.SPANISH_MEXICO_ID' })} tierData={tierData} /> },
  ], [formatMessage, tierData]);

  return (
    <section className="mt-10">
      <PageContainer>
        <div className="mb-3">
          <SectionTitle fontSize={FONT_SIZE.XXL} label={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_DISPLAY_SECTION_TITLE' })} />
        </div>
        <TabsComponent tabList={tabLangs} />
      </PageContainer>
    </section>
  )
}
